import {
  LUA_KEYWORD_REGEX,
  NUMERIC_REGEX,
  SYSTEM_ALPHANUMERIC_REGEX,
} from '@/app/utils/regexpr-const';
import { System } from '../types/system.interface';

export const validateAlphanumeric = (regex: RegExp, params: string) => {
  return new RegExp(regex).test(params);
};

export const validateEmpty = (params: string | Array<any>) => {
  return params.length === 0;
};

export const validateDuplicates = (x: string, y: string) => {
  return x === y;
};

export const validateGreaterThan = (x: number, y: number) => {
  return x > y;
};

export const validateLuaKeyWord = (params: string) => {
  return new RegExp(LUA_KEYWORD_REGEX).test(params);
};

export const validateNumber = (params: string) => {
  return new RegExp(NUMERIC_REGEX).test(params);
};

export const validateSystemName = (
  systemName: string,
  systems: Array<System>
) => {
  const isNameValid = new RegExp(SYSTEM_ALPHANUMERIC_REGEX).test(systemName);
  const isDuplicated =
    systems.filter(
      (item: System) =>
        item.systemName.toLowerCase() === systemName.toLowerCase()
    ).length > 0;

  return { isNameValid, isDuplicated };
};
